import React from "react";
import {Modal} from "antd";
import {PhoneOutlined, LoadingOutlined} from "@ant-design/icons";

/**
 * Generic Loading Modal - Uzun süren istekler için kullanıcı geri bildirimi
 * 
 * @param {Object} props
 * @param {boolean} props.visible - Modal görünür mü?
 * @param {string} props.title - Modal başlığı
 * @param {string} props.message - Ana mesaj
 * @param {string} props.subMessage - Alt mesaj
 * @param {string} props.icon - İkon (varsayılan: PhoneOutlined)
 * @param {string} props.iconColor - İkon rengi (varsayılan: #1890ff)
 * @param {boolean} props.showSpinner - Spinner göster (varsayılan: false)
 * @param {string} props.spinnerText - Spinner altındaki metin
 */
export const LoadingModal = ({
    visible,
    title = "İstek Gönderildi",
    message = "İstek gönderiliyor...",
    subMessage = "Lütfen bekleyin, işlem tamamlandığında bilgilendirileceksiniz.",
    icon: Icon = PhoneOutlined,
    iconColor = "#1890ff",
    showSpinner = false,
    spinnerText = "İşlem devam ediyor..."
}) => {
    return (
        <Modal
            title={
                <div style={{display: "flex", alignItems: "center", gap: "8px"}}>
                    <Icon style={{color: iconColor}} />
                    <span>{title}</span>
                </div>
            }
            visible={visible}
            footer={null}
            closable={false}
            maskClosable={false}
            centered
            style={{textAlign: "center"}}
        >
            <div style={{padding: "20px 0"}}>
                <div style={{fontSize: "16px", marginBottom: "16px", color: iconColor}}>
                    <Icon style={{fontSize: "24px", marginRight: "8px"}} />
                    {message}
                </div>
                
                {showSpinner && (
                    <div style={{textAlign: "center", marginBottom: "16px"}}>
                        <LoadingOutlined style={{fontSize: "20px", color: iconColor}} />
                        <div style={{marginTop: "8px", fontSize: "12px", color: "#666"}}>
                            {spinnerText}
                        </div>
                    </div>
                )}
                
                <div style={{fontSize: "12px", color: "#999"}}>
                    {subMessage}
                </div>
            </div>
        </Modal>
    );
};
